import { gql } from '@apollo/client';

export const LOGIN = gql`
query Login($input: Login!) {
  Login(input: $input) {
    name,
    token
    terms
    terms_url
    privacy_url 
  }
}
`;

export const USER_TYPE = gql`
  query GetUserType {
    GetUserType
  }
`;
